
import { IColumnDef } from '../../../../../Types/ColumnDefType';
import notImplemented from '../notImplemented/notImplemented';

const ListRutin: React.FC<
  React.PropsWithChildren<{ businessCollectionName: string }>
> = props => <>{notImplemented('ListRutin')(props)}</>;

export const createListRutin = (
  businessCollectionName: string,
  columnDefs: IColumnDef[],
  detailComp: any
) => notImplemented('ListRutin för ' + businessCollectionName);

/** @component */
export default ListRutin;
